import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import {
	Navigation,
	Pagination,
	Scrollbar,
	A11y,
	Autoplay,
} from 'swiper/modules';
import { Tcarousel } from '../../../type/carousel';
import { getCarouselActive } from '../../../service/carouselService';
import { MINIO } from '../../../data/data';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

const CarouselPrimary = () => {
	const [carouselList, setCarouselList] = useState<Tcarousel[]>([]);

	const getDataCarousel = async () => {
		const response = await getCarouselActive();
		if (!response?.error) {
			setCarouselList(response?.data);
		}
	};

	useEffect(() => {
		getDataCarousel();
	}, []);
	return (
		<>
			<Swiper
				modules={[Autoplay, Navigation, Pagination, Scrollbar, A11y]}
				spaceBetween={50}
				slidesPerView={1}
				centeredSlides={true}
				loop={true}
				autoplay={{
					delay: 1000,
					disableOnInteraction: false,
				}}
				pagination={{ clickable: true }}
			>
				{carouselList.map((item: Tcarousel, index: number) => {
					return (
						<SwiperSlide key={index}>
							<img
								src={`${MINIO}/${item.thumbnail}`}
								alt=""
							/>
						</SwiperSlide>
					);
				})}
			</Swiper>
		</>
	);
};

export default CarouselPrimary;
